import { Box, TextField } from "@mui/material";
import { useEffect, useState } from "react";

interface EmailInputProps {
  email: string;
  setEmail: (value: string) => void;
  setIsValid?: (valid: boolean) => void;
}

export default function EmailInput({
  email,
  setEmail,
  setIsValid,
}: EmailInputProps) {
  const [touched, setTouched] = useState(false);

  const isValidEmail = (value: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const error =
    touched && (!email || !isValidEmail(email))
      ? !email
        ? "El correo electrónico es obligatorio"
        : "Correo electrónico inválido"
      : "";

  useEffect(() => {
    if (setIsValid) setIsValid(!!email && isValidEmail(email));
  }, [email]);

  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
      <TextField
        label="Correo electrónico"
        variant="outlined"
        fullWidth
        value={email}
        onChange={(e) => setEmail(e.target.value.trim())}
        onBlur={() => setTouched(true)}
        error={Boolean(error)}
        helperText={error}
        type="email"
        placeholder="usuario@correo.com"
        inputProps={{
          maxLength: 100,
          style: { fontSize: 16 },
        }}
        sx={{
          bgcolor: "#F6F8FB",
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: error ? "#f44336" : "#ccc",
            },
            "&:hover fieldset": {
              borderColor: "#888",
            },
            "&.Mui-focused fieldset": {
              borderColor: error ? "#f44336" : "#1976d2",
            },
          },
        }}
      />
    </Box>
  );
}
